import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=686c865c&"
import script from "./AccountCard.vue?vue&type=script&lang=ts&"
export * from "./AccountCard.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=686c865c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports